// import {
//     checkVerifyCode,
//     fetchCustomerList,
//     fetchSpaces,
//     requestParentSignup,
//     requestValidateId,
//     sendVerifyCode
// } from "@/api/parent";
// import Vue from "vue";
// import i18n from "@/locales";

import Vue from "vue";
import { requestAppConsoleAuth } from "../../api";

export const state = {
    completed: false,
    result: {}
};

export const getters = {};

export const actions = {
    async REQUEST_AUTH({ commit, dispatch }, param) {
        try {
            const { data } = await requestAppConsoleAuth(param);
            commit("SET_RESULT", data);
            commit("SET_COMPLETE", true);
        } catch (e) {
            dispatch("UPDATE_ERROR_SNACKBAR", e);
        }
    }
};

export const mutations = {
    SET_COMPLETE(state, completed) {
        Vue.set(state, "completed", completed);
    },
    SET_RESULT(state, value) {
        Vue.set(state, "result", value);
    }
};
